'use client'

import { WithSuspenseBoundary } from '@/shared/api'
import { Layout } from '@/shared/ui'

import { ContractStatus } from './contract-status'
import { ErrorFallback, LoadingFallback } from './fallback'
import { HostPayReady } from './host-pay-ready'
import { Todo } from './to-do'

export const HostDashboard = () => {
  return (
    <section className="bg-gray-50">
      <Layout className="my-15 grid grid-cols-2 gap-5">
        <WithSuspenseBoundary
          active
          error={<ErrorFallback title="할 일" />}
          loading={<LoadingFallback title="할 일" />}
        >
          <Todo />
        </WithSuspenseBoundary>

        <WithSuspenseBoundary
          active
          error={<ErrorFallback title="정산 예정 임대료" />}
          loading={<LoadingFallback title="정산 예정 임대료" />}
        >
          <HostPayReady />
        </WithSuspenseBoundary>

        <WithSuspenseBoundary
          active
          error={<ErrorFallback title="계약 현황" className="col-span-2" />}
          loading={<LoadingFallback title="계약 현황" className="col-span-2" />}
        >
          <ContractStatus className="col-span-2" />
        </WithSuspenseBoundary>
      </Layout>
    </section>
  )
}
